import React from 'react';
import {FormGroup, Label} from "reactstrap";
import { useTranslation } from 'react-i18next';

const AppSelect = ({
                       placeholder = 'Selectionnez',
                       onChange = () => null,
                       onBlur = () => null,
                       label = '',
                       value = '',
                       name = '',
                       error = null,
                       touched = false,
                       required = false,
                        disabled = false,
                       children,
                       ...props
                   }) => {

    const { t } = useTranslation();
    return (
        <FormGroup>
            {label && (<Label
                htmlFor={name}
                className="control-label">
                {typeof label === 'string' ? t(label) : label}
            </Label>)} {required && <span className="text-danger">*</span>}
            <select id={name} name={name} value={value} className="form-control" placeholder="Selectionnez" onChange={onChange} onBlur={onBlur} disabled={disabled}>
                <option value="">{typeof placeholder === 'string' ? t(placeholder) : placeholder}</option>
                {children || null}
            </select>
            {error && touched && (
                <em className="text-danger font-small italic font-weight-bold">{typeof error === 'string' ? t(error) : error}</em>
            )}
        </FormGroup>
    )
};

export default AppSelect;